import { ModalID } from "@wt/game/modals/ImageModal/types";
import { LabelHTMLAttributes } from "react";

const ImageModalToggle = ({
  children,
  ...props
}: LabelHTMLAttributes<HTMLLabelElement>) => {
  return (
    <label htmlFor={ModalID} {...props}>
      {children}
    </label>
  );
};

export default ImageModalToggle;
